export let environment: { apiUrl: string; production: boolean };
environment = {
	production: false,
	apiUrl: 'http://www.vipspm-dev.com'
	// apiUrl: 'http://chetsapp.de:8899'
};
